import * as types from './action-types';
import api from '../utils/api';
import getAuth from '../utils/get-auth';

import 'whatwg-fetch';

export const createInvite = (invite) => {
  const { email } = invite;
  return (dispatch, getState) => {
    const auth = getAuth(getState());

    dispatch({
      type: types.CREATE_INVITE,
      payload: api('/invites', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${auth}`
        },
        body: JSON.stringify({ email })
      })
    })
  }
};

export const fetchInvites = () => {
  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.FETCH_INVITES,
      payload: api('/invites', {
        headers: { 'Authorization': `JWT ${auth}` }
      })
    })
  }
};

export const resendInvite = (invite) => {
  const { id } = invite;

  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.RESEND_INVITE,
      payload: api(`/invites/${id}/resend`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  };
}

export const cancelInvite = (invite) => {
  const { id } = invite;

  return (dispatch, getState) => {
    const auth = getAuth(getState());
    dispatch({
      type: types.CANCEL_INVITE,
      payload: api(`/invites/${id}/cancel`, {
        method: 'POST',
        headers: { 'Authorization': `JWT ${auth}` }
      })
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/invite-actions.js